<template>
  <div class="py-4">
    <div v-if="title" class="mb-2.5 flex items-baseline">
      <p
        :class="cn('ui-text-m mr-1.5 font-normal capitalize', labelClass)"
        :data-e2e-item="`${block.sku}-filter-group-${block.view_type}`"
      >
        {{ title }}:
      </p>
    </div>
    <div class="space-y-2.5">
      <button
        v-for="item in block.materials"
        :key="item.id"
        class="flex w-full items-center border p-4 text-sm disabled:border-gray-10 disabled:bg-gray-5 disabled:text-gray-30"
        :class="
          cn({
            'border-black font-bold': selectedItem?.id === item.id,
            'border-gray-10 bg-gray-5 text-gray-30':
              item.disabled && disabledButClickable,
          })
        "
        :disabled="!skipDisable && item.disabled && !disabledButClickable"
        :data-e2e-item="`${item.sku}-filter-${block.view_type}`"
        @click="onFilterClick(block.slug, item)"
      >
        <div class="pr-3 text-left">
          <div class="text-base leading-5">
            {{ item?.currentTranslation?.title }}
          </div>
          <div
            v-if="item?.currentTranslation?.short_description"
            class="mt-0.5 text-xs font-normal text-gray-80 [&_p]:text-xs [&_p]:font-normal [&_p]:text-gray-80"
            v-html="item.currentTranslation.short_description"
          />
        </div>
        <UiIcon
          :name="
            selectedItem?.id === item.id ? 'radio-checked' : 'radio-unchecked'
          "
          class="ml-auto size-6"
        />
      </button>
    </div>
    <SharedFieldHint :message="errorMessage" error />
    <slot name="additional" />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import {
  IProductMaterialFilterEvent,
  IProductMaterialFilterProps,
  MaterialData,
} from "ecom-types";

const props = defineProps<
  IProductMaterialFilterProps & {
    skipDisable?: boolean;
    disabledButClickable?: boolean;
  }
>();

const emit = defineEmits<{
  (e: "filter", value: IProductMaterialFilterEvent): void;
}>();

const { errorMessage, setValue } = useField(props.block?.slug, undefined, {
  initialValue: props.selectedItem?.sku,
});

watch(
  () => props.selectedItem,
  () => {
    setValue(props.selectedItem?.sku || "");
  },
  { deep: true },
);

function onFilterClick(slug: string, item: MaterialData) {
  setValue(item.sku);
  emit("filter", { slug, item });
}
</script>
